import {createFileRoute} from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/home/discover')({
  staticData: {crumbKey: 'navigation.discover'},
});
